import React, { Component } from 'react'
import { PropTypes } from 'prop-types'
import IPropTypes from 'react-immutable-proptypes'
import { SmoothScrollbar } from 'gnos-scrollbar'

import StackPreloader from '../../../StackPreloader'

import ExportsRow from './components/ExportsRow'

import { TASK_PRIORITIES } from './constants'

import hocConnect from './hocConnect'

import './style.scss'

@hocConnect
export default class ExportsContent extends Component {
    static propTypes = {
        exportsInitLoad: PropTypes.func.isRequired,
        jobs: IPropTypes.map,
        loaded: PropTypes.bool,
        loading: PropTypes.bool,
    }

    componentDidMount() {
        const { loaded, exportsInitLoad } = this.props

        if (!loaded) exportsInitLoad()
    }

    renderLoader = () => {
        const { loading, loaded } = this.props

        return loading || !loaded ? <StackPreloader /> : null
    }

    render() {
        const { jobs } = this.props

        return (
            <div className={'entity-stack-exports-content'}>
                {this.renderLoader()}
                <SmoothScrollbar>
                    {jobs
                        .sortBy((job) => job?.meta?.fileName)
                        .sortBy((job) => TASK_PRIORITIES[job?.state])
                        .valueSeq()
                        .map((job, index) => (
                            <ExportsRow key={`entity-stack-exports-content-row-${index}`} data={job} />
                        ))}
                </SmoothScrollbar>
            </div>
        )
    }
}
